import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import * as en from './en/en';

export const translations: TranslationResources = {
  en,
};

function extractKeys(obj: any): any {
  const result: any = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = Object.keys(obj[key]);
    }
  }

  return result;
}

export const translationChunksConfig: TranslationChunksConfig = extractKeys(en);
